import { Component, Input } from '@angular/core';
import { IMasterTemplate } from '../../data/interfaces';

@Component({
  selector: 'app-template-preview',
  templateUrl: './template-preview.component.html',
  styleUrls: ['./template-preview.component.scss']
})
export class TemplatePreviewComponent {
  @Input() template: IMasterTemplate | null = null;
  @Input() channel: 'email' | 'sms' | 'whatsapp' | 'call' = 'email';

  sampleData = {
    clientName: 'Juan Pérez',
    leaseNumber: 'L-001234',
    amount: '$15,000.00',
    dueDate: '30 de Octubre, 2025',
    paymentLink: 'https://rendafin.com/pay/L-001234',
    companyName: 'Rendafin',
    clientEmail: 'juan.perez@example.com',
    clientPhone: '+52 55 1234 5678',
    daysOverdue: '3',
    totalDebt: '$45,000.00'
  };

  get previewContent(): string {
    if (!this.template) return '';
    
    let content = '';
    
    switch (this.channel) {
      case 'email':
        content = this.template.emailTemplate?.html || '';
        break;
      case 'sms':
        content = this.template.smsTemplate?.message || '';
        break;
      case 'whatsapp':
        content = this.template.whatsappTemplate?.message || '';
        break;
      case 'call':
        const script = this.template.callScript;
        content = `${script?.greeting || ''}\n\n${script?.mainMessage || ''}\n\n${script?.closing || ''}`;
        break;
    }
    
    // Reemplazar variables con datos de ejemplo
    return this.replaceVariables(content);
  }

  replaceVariables(text: string): string {
    let result = text;
    Object.entries(this.sampleData).forEach(([key, value]) => {
      const regex = new RegExp(`\\{\\{${key}\\}\\}`, 'g');
      result = result.replace(regex, value);
    });
    return result;
  }
}
